export default __webpack_public_path__ + "static/media/moon_gray.64a41d93.svg";